import React, { createContext, useContext } from 'react';

type K9ChromeContextValue = {
  /** Main site Header (with APT logo) is rendered above K9Layout */
  hasGlobalSiteHeader: boolean;
};

const K9ChromeContext = createContext<K9ChromeContextValue>({
  hasGlobalSiteHeader: false,
});

export function K9ChromeProvider({
  hasGlobalSiteHeader,
  children,
}: {
  hasGlobalSiteHeader: boolean;
  children: React.ReactNode;
}) {
  return (
    <K9ChromeContext.Provider value={{ hasGlobalSiteHeader }}>
      {children}
    </K9ChromeContext.Provider>
  );
}

export function useK9Chrome(): K9ChromeContextValue {
  return useContext(K9ChromeContext);
}
